<template>
  <!-- 申请许可页面    路由跳转 #/OnlineAuthorization -->
  <div
    class="OnlineAuthorizationStyle"
    style="height: 100vh; overflow-y: scroll; overflow-x: hidden"
  >
    <!-- top 头部 -->
    <div style="position: relative">
      <div class="tittleStyle">
        <div style="height: 200px"></div>
        <span>申请授权</span>
      </div>
    </div>
    <div class="boxBorderStyle">
      <!-- 主体  1 -->
      <div style="background: #000">
        <div style="background: #fff; height: auto" class="stepsStyle">
          <div style="margin: 0px auto; padding: 10px; background: #fff">
            <div class="topTittle">申请授权只需三步</div>
            <el-steps :active="activenum" align-center>
              <el-step title="选择许可" description></el-step>
              <el-step title="身份登记" description></el-step>
              <el-step title="获得授权" description></el-step>
            </el-steps>
          </div>
        </div>

        <div class="firstStepStatiousStyle" v-show="firstStepStatious">
          <!-- 第一步 -->
          <div style class="permitstyle">
            <span class="NextstepStyle">
              1)
              <span style="margin-left: 10px">选择许可</span>
            </span>
            <div style="height: 15px"></div>
            <el-form
              :label-position="labelPosition"
              label-width="120px"
              :model="formLabelAlign"
              size="mini"
              class="firstminiStyle"
            >
              <el-form-item label="产品选择" prop="type">
                <el-checkbox-group v-model="formLabelAlign.type">
                  <el-checkbox label="PIEBasic" name="type"></el-checkbox>
                  <el-checkbox label="PIEOrtho" name="type"></el-checkbox>
                  <el-checkbox label="PIEMap" name="type"></el-checkbox>
                  <el-checkbox label="PIEAI" name="type"></el-checkbox>
                  <el-checkbox label="PIEHyp" name="type"></el-checkbox>
                  <el-checkbox label="PIESAR" name="type"></el-checkbox>
                  <el-checkbox label="PIESIAS" name="type"></el-checkbox>
                  <el-checkbox label="PIEUAV" name="type"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="录入机器码">
                <el-input
                  maxlength="8"
                  v-model="formLabelAlign.machineCode"
                  placeholder="输入机器码"
                  style="width: 90%; height: 40px"
                ></el-input>
                <br />
                <span
                  >注：请先下载所需软件程序并启动，软件会自动提示机器码信息。</span
                >
              </el-form-item>
            </el-form>
            <el-form
              :inline="true"
              :model="formInline"
              class="demo-form-inline OnlineAuthorizationInlineFormStyle"
            >
              <el-form-item label="手机号码">
                <el-input
                  class="phonewidth"
                  v-model="formInline.inputPhone"
                  placeholder="请输入手机号码"
                ></el-input>
              </el-form-item>
              <el-form-item class="codeAndNumStyle">
                <el-button
                  type="primary"
                  v-show="showphonesuccess"
                  @click="getPhoneCode"
                  >获取验证码</el-button
                >
                <el-button
                  type="primary"
                  disabled
                  v-show="getphoneError"
                  @click="getPhoneCode"
                  >{{ this.count }}秒</el-button
                >
              </el-form-item>
              <el-form-item label class="codeStyle">
                <el-input
                  v-model="formInline.inputCode"
                  placeholder="请输入手机验证码"
                  class="inputCodeStyle"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="firstNextStyle" style>
            <div>
              <el-button
                type="primary"
                class="firstNextBtnStyle"
                @click="next"
                style
                >下一步</el-button
              >
            </div>
          </div>
          <div style="height: 15px"></div>
        </div>
      </div>

      <div class="secondStepStatiousStyle" v-show="secondStepStatious">
        <!-- 第二步 -->
        <div style class="userInforStyle">
          <span class="NextstepStyle">
            2)
            <span style="margin-left: 10px">身份登记</span>
          </span>
          <div style="height: 15px"></div>
          <el-form
            :inline="true"
            :model="formInline"
            class="demo-form-inline OnlineAuthorizationInlineFormStyle"
          >
            <el-form-item label="单位名称">
              <el-input
                v-model="formInline.companyName"
                class="companyNameStyle"
                placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="所属行业">
              <el-input
                v-model="formInline.industry"
                class="industryStyle"
                placeholder="请输入所属行业"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-form
            :label-position="labelPosition"
            label-width="80px"
            :model="formLabelAlign"
            size="mini"
            class="miniStyle"
          >
            <el-form-item label="单位地址">
              <el-input
                v-model="formLabelAlign.address"
                placeholder="请输入单位地址"
                class="addressStyle"
                style
              ></el-input>
            </el-form-item>
          </el-form>

          <el-form
            :inline="true"
            :model="formInline"
            class="demo-form-inline OnlineAuthorizationInlineFormStyle"
          >
            <el-form-item label=" 联系人" class="userStyle">
              <el-input
                v-model="formInline.user"
                class="userWidth"
                placeholder="请输入联系人名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱地址">
              <el-input
                v-model="formInline.email"
                class="emailStyle"
                placeholder="请输入邮箱地址"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-form
            :label-position="labelPosition"
            label-width="80px"
            :model="formLabelAlign"
            size="mini"
            class="miniStyle"
          >
            <el-form-item label="软件用途" prop="desc">
              <el-input
                type="text"
                v-model="formLabelAlign.application"
                class="applicationStyle"
                style
              ></el-input>
            </el-form-item>
          </el-form>
          <div>
            <el-button
              type="primary"
              @click="nextGetResult"
              class="nextGetResultStyle"
              style
              >下一步</el-button
            >
          </div>
          <div style="height: 15px"></div>
        </div>
      </div>

      <div class="threeStepStatiousStyle" v-show="threeStepStatious">
        <!-- 第三步 -->
        <div style="margin: 0 auto">
          <div style="height: 20px"></div>
          <span class="threeNextstepStyle">
            3)
            <span style="margin-left: 10px">获得授权</span>
          </span>
          <div style="height: 15px"></div>
          <div v-for="item in authorizationResultData" :key="item.szProduct">
            <div class="titleLeftDivnBoxStyle" style>
              <div class="titleLeftDivStyle" style>
                <div class="titleLeftDivNameStyle" style>
                  航天宏图信息技术股份有限公司
                </div>
                <img
                  style="margin-top: 20px"
                  src="./../../../public/img/OnlineAuthorization/download.svg"
                  alt
                />
              </div>
              <div class="AuthorizationCodeStyle" style>
                <div style="margin-left: 70px">
                  <div class="szProductStyle" style>
                    现授于用户使用 {{ item.szProduct }} 的权限！
                  </div>
                  <div class="activeCodeStyle" style>
                    <div>授权码：{{ item.activeCode }}</div>
                  </div>
                  <div class="szMachineEncryStyle" style>
                    <div>机器码：{{ item.szMachineEncry }}</div>
                  </div>
                  <div class="DateStyle" style>
                    <div>有效期：{{ newTodayDate }}至{{ item.szEndDate }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div style="width:800px;margin:0 auto;margin-top:10px">
        <el-button type="primary" @click="submitForm()" style="width:140px;margin: 0px 330px;">已保存授权</el-button>
        </div>-->
        <div style="height: 15px"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      TipsModelData: [], //重复获取授权码的产品信息
      count: "", //计时数值
      timer: null, //计时器
      getphoneError: false, //倒计时按钮状态
      showphonesuccess: true, //获取验证码按钮状态
      newTodayDate: "", //当前日期
      authorizationResultData: [], //授权结果
      activenum: 1, //步骤显示
      firstStepStatious: true, //第一步
      secondStepStatious: false, //第二步
      threeStepStatious: false, //第三步
      labelPosition: "left", //表单lable位置
      formLabelAlign: {
        type: [], //产品类型
        address: "", //地址
        application: "", //用途
        machineCode: "", //机器码
      },
      formInline: {
        user: "", //联系人
        email: "", //邮箱
        companyName: "", //企业名称
        inputPhone: "", //手机号
        industry: "", //行业
        inputCode: "", //验证码
      },
    };
  },
  mounted() {
    this.getNewTodayDate(); //获取当前最新的日期
    this.byTokenSearchPhone();
  },
  methods: {
    // 手机格式验证
    checkPhone(phone) {
      let postPhone = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/;
      let keyPhone = postPhone.test(phone);
      if (!keyPhone) {
        return false;
      } else {
        return true;
      }
    },
    byTokenSearchPhone() {
      let that = this;
      let path = httpengine + "/dev/account/api/sys/user/queryUserByToken";
      that.http.get(path).then((res) => {
        if (true == res.data.success) {
          that.formInline.inputPhone = res.data.data.mobile;
        } else {
          //
        }
      });
    },
    //   第一个界面的下一步按钮
    next() {
      let that = this;
      if (0 == that.formLabelAlign.type.length) {
        that.$message.warning("请选择产品");
        return;
      } else if ("" == that.formLabelAlign.machineCode) {
        that.$message.warning("请输入机器码");
        return;
      } else if ("" == that.formInline.inputPhone) {
        that.$message.warning("请输入手机号");
        return;
      } else if ("" == that.formInline.inputCode) {
        that.$message.warning("请输入手机验证码");
        return;
      } else {
        that.VerifyPhoneCode(); //线上手机验证码验证
      }
    },
    // 获取用户的信息
    getUserInfor() {
      let that = this;
      let path = httpengine + "/pie-authorization/user/userInfo/searchByPhone";
      let param = {
        phone: that.formInline.inputPhone,
      };
      that.http.get(path, param).then((res) => {
        if (true == res.data.success) {
          that.formInline.companyName = "";
          that.formInline.industry = "";
          that.formLabelAlign.address = "";
          that.formInline.user = "";
          that.formInline.email = "";
          that.formLabelAlign.application = "";
          that.activenum = 2;
          that.firstStepStatious = false;
          that.secondStepStatious = true;
          that.threeStepStatious = false;
        } else if (false == res.data.success) {
          // 手机已经获取过软件注册
          that.showTips(res.data.data);
        } else {
          return;
        }
      });
    },

    // 提示已经勾选的产品有获取过授权码的
    showTips(data) {
      let that = this;
      that.formInline.companyName = data[0].companyName;
      that.formInline.industry = data[0].industry;
      that.formLabelAlign.address = data[0].address;
      that.formInline.user = data[0].username;
      that.formInline.email = data[0].email;
      that.formLabelAlign.application = data[0].application;
      let prepareData = [];
      that.TipsModelData = [];
      let existsData = that.formLabelAlign.type;

      for (let i = 0; i < data.length; i++) {
        prepareData.push(data[i].softwareVersion);
        let index = existsData.indexOf(data[i].softwareVersion);
        if (-1 != index) {
          that.TipsModelData.push(data[i].softwareVersion);
        }
      }

      if (0 != that.TipsModelData.length) {
        that.activenum = 1;
        that.firstStepStatious = true;
        that.secondStepStatious = false;
        that.threeStepStatious = false;
        that.open(that.TipsModelData);
      } else if (0 == that.TipsModelData.length) {
        that.activenum = 2;
        that.firstStepStatious = false;
        that.secondStepStatious = true;
        that.threeStepStatious = false;
      } else {
        return;
      }
    },

    // 提示用户已经获取过验证码的产品
    open(Product) {
      let that = this;
      let dataString = Product.join(",");
      that.$message({
        showClose: true,
        duration: 10000,
        message: "重复获取授权码的产品" + dataString,
      });
    },
    // 获取手机验证码
    getPhoneCode() {
      let that = this;

      let path = "https://janus.piesat.cn/gateway/api";
      let x_api = "engine.login.getVerifyCode";
      let param = {
        telOrMail: that.formInline.inputPhone,
        type: "MOBILE",
        action: "Login",
      };
      that.http
        .get(path, param, x_api)
        .then((res) => {
          if (res.data.code == 0) {
            that.showphonesuccess = false;
            that.getphoneError = true;
            const TIME_COUNT = 300;
            if (!self.timer) {
              that.count = TIME_COUNT;
              that.timer = setInterval(() => {
                if (that.count > 0 && that.count <= TIME_COUNT) {
                  that.count--;
                } else {
                  clearInterval(that.timer);
                  that.timer = null;
                  that.showphonesuccess = true;
                  that.getphoneError = false;
                }
              }, 1000);
            }
          } else {
            that.$message.warning(res.data.message);
            that.showphonesuccess = true;
            that.getphoneError = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });

      // let path = that.GlobalUrlPath.OnlineAuthorization.getCodeByTel;
      // let path = httpengine + "/dev/account/api/auth/getCodeByTel";
      // let param = {
      //   tel: that.formInline.inputPhone,
      // };
      // this.http.get(path, param).then((res) => {
      //   if (false == res.data.success) {
      //   } else if (true == res.data.success) {
      //   }

      //   console.log("获取手机验证码");
      // });
    },

    // 验证手机验证码
    VerifyPhoneCode() {
      let that = this;
      // let path = that.GlobalUrlPath.OnlineAuthorization.checkTelWithCode;
      let path = httpengine + "/dev/account/api/auth/checkTelWithCode";
      let param = {
        tel: that.formInline.inputPhone,
        captcha: that.formInline.inputCode,
      };
      let ss = this.http.get(path, param).then((res) => {
        if (false == res.data.success) {
          that.$message.warning(res.data.message);
        } else {
          that.getUserInfor(); //获取用户的信息
        }
        console.log("手机验证码验证");
      });
    },

    // 获取当前日期
    getNewTodayDate() {
      let that = this;
      let now = new Date();
      let year = now.getFullYear(); //得到年份
      let month = now.getMonth(); //得到月份
      let date = now.getDate(); //得到日期
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      let clock = "";
      clock = year + "-" + month + "-" + date;
      that.newTodayDate = clock;
    },

    // 获取软件截止日期
    getDay() {
      let that = this;
      let now = new Date();
      let year = now.getFullYear(); //得到年份
      let month = now.getMonth(); //得到月份
      let date = now.getDate(); //得到日期
      month = month + 2;

      if (month == 13) {
        year += 1;
        month = 1;
      }
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      let clock = "";
      clock = year + "-" + month + "-" + date;
      // console.log("clock", clock);
      return clock;
    },
    //第二个界面下一步，提交申请信息，获得申请结果
    nextGetResult() {
      let that = this;
      let path = httpiecloud + "/lic/api/v1/licserver";
      let param = [];
      let tempdata = that.formLabelAlign.type;
      if (0 == tempdata.length) {
        this.$message.warning("请选择产品");
        return;
      } else if ("" == that.formInline.companyName) {
        this.$message.warning("请填写单位名称");
        return;
      } else if ("" == that.formInline.industry) {
        this.$message.warning("请填写单位所属行业");
        return;
      } else if ("" == that.formLabelAlign.address) {
        this.$message.warning("请填写单位地址");
        return;
      } else if ("" == that.formInline.user) {
        this.$message.warning("请填写联系人");
        return;
      } else if ("" == that.formInline.email) {
        this.$message.warning("请填写邮箱地址");
        return;
      } else if ("" == that.formLabelAlign.application) {
        this.$message.warning("请填写软件用途");
        return;
      } else {
        let tempObject = {
          nType: 0, //许可类型 0:软License， 1:硬License
          szMachineEncry: that.formLabelAlign.machineCode, //机器码
          szEndDate: that.getDay(), //软件截止日期  默认30天
          bFloat: 0, //是否浮动许可 0:单机， 1:浮动
          // szProduct: szProduct + "=0",
          /**
           * 产品字符串列表，用“;”分割  产品名称=浮动个数
           * 浮动许可: PIEBasic=10;PIEOrtho=20
           * 单价许可: PIEBasic=0;PIEOrtho=0
           */
        };

        // 拼接产品名称
        let product = "";
        for (let i = 0; i < tempdata.length; i++) {
          product += tempdata[i] + "=0";
          if (i != tempdata.length - 1) {
            product += ";";
          }
        }
        tempObject.szProduct = product;
        param.push(tempObject);
      }
      this.http.post(path, param).then((res) => {
        if (200 == res.data.code) {
          that.activenum = 3;
          that.firstStepStatious = false;
          that.secondStepStatious = false;
          that.threeStepStatious = true;
        }
        let resData = res.data.data;
        // 结果处理展示
        if (null == resData[0].activeCode) {
          that.$message.warning("输入的机器码不存在或者无效");
          that.activenum = 1;
          that.firstStepStatious = true;
          that.secondStepStatious = false;
          that.threeStepStatious = false;
        } else {
          that.showResult(resData);
        }
        console.log("申请结果", res);
      });
    },

    // 第三步的界面展示
    showResult(data) {
      let that = this;
      that.authorizationResultData = [];
      let tempUserCode = [];
      let tempszProduct = [];
      let numType = "0";
      let templength = data.length;
      for (let i = 0; i < templength; i++) {
        let temp = {
          activeCode: data[i].activeCode,
          nType: data[i].nType,
          szEndDate: data[i].szEndDate,
          szMachineEncry: data[i].szMachineEncry,
          // szProduct: data[i].szProduct.split("=")[0],
        };
        // 拼接产品名称

        let product = "";
        for (let i = 0; i < that.formLabelAlign.type.length; i++) {
          product += that.formLabelAlign.type[i];
          if (i != that.formLabelAlign.type.length - 1) {
            product += ",";
          }
        }
        temp.szProduct = product;
        tempUserCode.push(data[i].activeCode);
        tempszProduct.push(product);
        that.authorizationResultData.push(temp);
      }

      that.ParsingResult(data, numType);
    },

    // 解析結果信息
    ParsingResult(data, numType) {
      let that = this;
      let tempUserCode = [];
      let tempszProduct = [];
      let szProductArr = data[0].szProduct.split(";");
      for (let i = 0; i < szProductArr.length; i++) {
        tempUserCode.push(data[0].activeCode);
        tempszProduct.push(szProductArr[i].split("=")[0]);
      }

      that.saveUserInfo(tempUserCode, tempszProduct, numType);
    },
    // 保存用户信息
    saveUserInfo(data, szProduct, numType) {
      let that = this;
      // let path = that.GlobalUrlPath.OnlineAuthorization.userInfo;
      let path = httpengine + "/pie-authorization/user/userInfo";
      let param = {
        address: that.formLabelAlign.address,
        application: "",
        authorizationMethod: parseInt(numType), //是否浮动许可 0:单机， 1:浮动
        companyName: that.formInline.companyName,
        email: that.formInline.email,
        expirationDate: that.getDay(),
        industry: that.formLabelAlign.Area,
        license: data.join(","),
        machineCode: that.formLabelAlign.desc,
        phone: that.formLabelAlign.Phone,
        softwareVersion: szProduct.join(","),
        status: 1,
        username: that.formInline.user,
      };
      this.http.post(path, param).then((res) => {
        console.log("保存用户信息", res);
      });
    },
  },
};
</script>

<style scoped>
.tittleStyle {
  width: 100%;
  height: 335px;
  background: url(./../../../public/img/OnlineAuthorization/OnlineAuthorization.png)
    no-repeat 4px 5px;
  color: rgb(255, 255, 255);
  font-size: 2rem;
  top: 200px;
  /* font-family: cursive; */
  text-align: center;
  width: 100%;
}
.boxBorderStyle {
  width: 50%;
  margin: 0px auto;
  box-shadow: #b97676 0px 0px 30px 5px inset;
  position: relative;
  top: -70px;
  border: 2px solid rgb(240, 237, 237);
}
.nextboxBorderStyle {
  width: 50%;
  margin: 0px auto;
  box-shadow: #aaa6a6 0px 0px 30px 5px inset;
  position: relative;
  top: -70px;
  border: 2px solid rgb(240, 237, 237);
}
.topTittle {
  text-align: center;
  height: 50px;
  margin-top: 50px;
}
.firstStepStatiousStyle,
.secondStepStatiousStyle {
  /* height: calc(100vh - 580px); */
  background: #fff;
}
.threeStepStatiousStyle {
  /* min-height: calc(100vh - 580px); */
  background: #fff;
}
.NextstepStyle {
  font-size: 16px;
  color: rgb(27, 157, 252);
  font-family: sans-serif;
  /* margin-left: -10px; */
}
.threeNextstepStyle {
  font-size: 16px;
  color: rgb(27, 157, 252);
  font-family: sans-serif;
  margin-left: 75px;
}
.permitstyle,
.firstNextStyle {
  width: 800px;
  margin: 0px auto 40px;
}
.permitstyle {
  margin-left: 110px;
}
.userInforStyle {
  width: 800px;
  margin: 0px auto;
  margin-left: 160px;
}
.firstNextBtnStyle,
.nextGetResultStyle {
  width: 140px;
  margin: 0px 330px;
}
.nextGetResultStyle {
  margin: 40px 260px;
}
.addressStyle,
.applicationStyle {
  width: 90%;
  height: 40px;
}
.activeCodeStyle,
.szMachineEncryStyle,
.DateStyle {
  margin-top: 30px;
  font-size: 16px;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}
.DateStyle {
  margin-top: 10px;
}
.DateStyle {
  margin-top: 40px;
}
.szProductStyle {
  margin-top: 50px;
  font-size: 20px;
}
.AuthorizationCodeStyle {
  float: right;
  width: 62%;
  height: 300px;
  margin-left: -44px;
  margin-right: 25px;
}
.titleLeftDivStyle {
  float: left;
  width: 40%;
  height: 300px;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.titleLeftDivNameStyle {
  text-align: center;
  margin-top: 50px;
  color: rgb(27, 157, 252);
}
.titleLeftDivnBoxStyle {
  background: rgba(27, 157, 252, 0.1);
  height: 306px;
  width: 85%;
  margin: 0 auto;
  margin-top: 10px;
}
/* 1920 x 150% */
@media screen and (max-width: 1280px) {
  .firstminiStyle {
    width: 600px;
  }
  .OnlineAuthorizationInlineFormStyle {
    width: 600px;
  }
  .phonewidth {
    width: 334px;
  }
  .inputCodeStyle {
    width: 244px;
  }
  .firstNextBtnStyle {
    margin: 0px 247px;
  }
  .nextGetResultStyle {
    margin: 40px 247px;
  }
  .permitstyle,
  .userInforStyle {
    margin-left: 30px;
  }
  .companyNameStyle,
  .industryStyle,
  .emailStyle {
    width: 450px;
  }
  .userWidth {
    width: 444px;
  }
  .addressStyle,
  .applicationStyle {
    width: 80%;
  }
  .activeCodeStyle,
  .szMachineEncryStyle,
  .DateStyle {
    margin-top: 20px;
    font-size: 14px;
  }
  .AuthorizationCodeStyle {
    width: 65%;
    margin-left: -55px;
  }
  .titleLeftDivStyle {
    width: 35%;
    margin-left: 20px;
  }
  .titleLeftDivNameStyle {
    font-size: 12px;
  }
  .szProductStyle {
    font-size: 18px;
    margin-top: 44px;
  }
  .firstNextStyle {
    margin: 40px auto;
  }
}
</style>